<template>
  <div class="radius-border bg-white" :class="selected?'active':''">
    <div v-if="isAdd" class="brand-item-wrap flex flex-col items-center justify-center relative">
      <van-image class="-mt-10" :src="require('@/assets/icons/v2/icon_brand_add_new.png')" fit="contain" width="40"
          height="40"/>
      <span class="add-new">Add New</span>
    </div>

    <div @click="onSelectProductClick"  v-else class="brand-item-wrap relative flex flex-col items-center p-2 justify-center">
      <van-image :src="productInfo.deviceImage" fit="contain" style="max-width:92%;" height="62">
        <template v-slot:loading>
          <van-loading type="spinner" size="50" />
        </template>
      </van-image>
      <div v-if="showName" class="text-10px mt-1.5 text-center">{{ productInfo.deviceName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isAdd: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: false
    },
    productInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  name: "ProductItem",
  methods: {
    onSelectProductClick() {
      this.$emit("onSelectProduct");
    }
  },
  mounted() {

  }
};
</script>


<style scoped lang="less">
.brand-item-wrap {
  background: #FFFFFF;
  border-radius: 12px;
  //width: 149px;
  //height: 150px;
}

.active {
  border-radius: 12px;
  border: 1px solid #679AFF;
}

.pending {
  position: absolute;
  background: #F1F6FF;
  border-radius: 4px;
  width: 49px;
  height: 20px;
  line-height: 20px;
  top: 12px;
  right: 12px;
  font-size: 10px;
}

.add-new {
  position: absolute;
  border-radius: 4px;
  bottom: 12px;
  left: 12px;
  right: 12px;
  font-size: 12px;
}
</style>